import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV } from "@/constants/testIds";

const LINKS_V1 = [
  { key: "shift", label: "The Shift", href: "#shift" },
  { key: "whatwedo", label: "What We Do", href: "#whatwedo" },
  { key: "ally-vault", label: "Ally & Vault", href: "#ally-vault" },
  { key: "whynow", label: "Why Now", href: "#whynow" },
  { key: "privacy", label: "Privacy", href: "#privacy" },
  { key: "faq", label: "FAQ", href: "#faq" },
];

const LINKS_V2 = [
  { key: "whatwedo", label: "What We Do", href: "#whatwedo" },
  { key: "ally-vault", label: "Ally & Vault", href: "#ally-vault" },
  { key: "whynow", label: "Why Now", href: "#whynow" },
  { key: "faq", label: "FAQ", href: "#faq" },
];

export default function Nav({ variant = "v1" }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const links = variant === "v2" ? LINKS_V2 : LINKS_V1;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleAnchor = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <header
      data-testid={NAV.root}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#ffffff]/85 border-b border-black/10"
          : "backdrop-blur-md bg-[#ffffff]/40 border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid={NAV.logo}
          className="flex items-center gap-2"
        >
          <img
            src="/arvios-vault-logo.svg"
            alt="Arvios Vault"
            className="h-6 md:h-7 w-auto"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.key}
              href={l.href}
              data-testid={NAV.link(l.key)}
              onClick={(e) => handleAnchor(e, l.href)}
              className="font-mono text-[12px] uppercase tracking-[0.18em] text-black/65 hover:text-black transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#book"
            onClick={(e) => handleAnchor(e, "#book")}
            data-testid={NAV.cta}
            className="btn-primary hidden md:inline-flex"
          >
            Book a call
          </a>
          <button
            data-testid={NAV.mobileToggle}
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden text-[#0a0a0a] p-2 border border-black/25"
            aria-label="Toggle navigation"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-black/10 bg-[#ffffff]/98 backdrop-blur-xl">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.key}
                href={l.href}
                onClick={(e) => handleAnchor(e, l.href)}
                className="font-mono text-xs uppercase tracking-[0.18em] text-black/80"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#book"
              onClick={(e) => handleAnchor(e, "#book")}
              className="btn-primary self-start"
            >
              Book a call
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
